module.exports = __webpack_public_path__ + "static-portal/img/2.a1a8560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.png
// module id = NKGv
// module chunks = 4